import * as type from "../../types/API/productionProcess";

export function createProductionProcess(payload: any) {
  return {
    type: type.CREATE_PRODUCTION_PROCESS,
    payload: payload,
  };
}

export function getProductionProcess(payload: any) {
  return {
    type: type.GET_PRODUCTION_PROCESS,
    payload: payload,
  };
}

export function getProductionProcessById(payload: any) {
  return {
    type: type.GET_PRODUCTION_PROCESS_BY_ID,
    payload: payload,
  };
}

export function updateProductionProcess(payload: any) {
  return {
    type: type.UPDATE_PRODUCTION_PROCESS,
    payload: payload,
  };
}

export function deleteProductionProcess(payload: any) {
  return {
    type: type.DELETE_PRODUCTION_PROCESS,
    payload: payload,
  };
} 